import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { viewURL } from "../../helpers/functions/stringFormatter";

const ViewButton = (props) => {
  const { file, fileName, className } = props;
  const [isHovered, setIsHovered] = useState(false);

  return (
    <>
      {/* <a
        href={viewURL(file)}
        target="_blank"
        rel="noreferrer"
        className="btn btn-light"
        style={{
          fontSize: "13px",
          // color: "rgb(254, 254, 254)",
          color: "rgb(33, 150, 243)",
          backgroundColor: "rgb(255, 255, 255)",
          // backgroundColor: "rgb(33, 150, 243)",
          paddingTop: "3px",
          paddingBottom: "2px",
          marginTop: "0px",
          marginBottom: "0px",
          paddingRight: "2px",
          paddingLeft: "0px",
          width: "70px",
          borderRadius: 0,
          fontFamily: "emoji",
          fontWeight: "700",
          cursor: "pointer",
          round: "5%",
        }}
      >
        <i
          class="bi bi-eye"
          style={{ fontWeight: 200, marginRight: "2px" }}
        ></i>{" "}
        View
      </a> */}

      <button
        type="button"
        className={className ? className : "btn btn-outline-light"}
        style={{
          fontSize: "13px",
          color: "rgb(0,0,0)",
          backgroundColor: "#ffffff",
          // paddingTop: "3px",
          // paddingBottom: "4px",
          // marginTop: "2px",
          // marginBottom: "5px",
          // marginLeft: "2px",
          // marginRight: "2px",
          // paddingRight: "2px",
          // paddingLeft: "1px",
          // width: "80px",
          // borderRadius: "4px",
          // fontFamily: "inherit",
          // fontWeight: "600",
          cursor: "pointer",
          border: "1px solid rgb(33, 150, 243)",
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onClick={() => window.open(viewURL(file), "_blank", "noreferrer")}
      >
        <i className="bi bi-eye me-1"></i> View
      </button>
    </>
  );
};

export default ViewButton;
